
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/qualtrics",
      function () {
        return require("private-next-pages/destinations/qualtrics.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/qualtrics"])
      });
    }
  